import React from 'react'
import { List, Row, Tag, Tooltip, Typography } from 'antd'
import moment from 'moment'

import UserAvatar from 'src/components/UserAvatar'
import { useT } from 'src/core/hooks/use-translation'
import { RequestItinerary } from 'src/types'

import { getStatusColor } from '..'

import { ContainerUserAvatar } from './styles'

interface Props {
  item: RequestItinerary
}

function ItineraryItem({ item }: Props) {
  const { t } = useT()

  return (
    <List.Item>
      <List.Item.Meta
        title={
          <Tag color={getStatusColor(item.status)}>
            {t(`web.itinerary.status-check-in.${item.status}`)}
          </Tag>
        }
        description={
          <>
            <Row>
              {item.travelers.map(itemTraveler => (
                <Tooltip key={itemTraveler.user_id} title={itemTraveler.name}>
                  <ContainerUserAvatar>
                    <UserAvatar
                      gender={itemTraveler.gender}
                      name={itemTraveler.name}
                    />
                  </ContainerUserAvatar>
                </Tooltip>
              ))}
            </Row>
            <Row>
              <Typography.Text strong>
                {`${t('web.itinerary.form.activity.title')}: `}
              </Typography.Text>
              {item.activity}
            </Row>
            <Row>
              <Typography.Text strong>
                {`${t('web.itinerary.form.place.title')}: `}
              </Typography.Text>
              {item.description}
            </Row>
            <Row>
              <Typography.Text strong>
                {`${t('web.itinerary.form.reference.title')}: `}
              </Typography.Text>
              {item.reference.name}
            </Row>
            <Row>
              <Typography.Text strong>
                {`${t('web.itinerary.form.start')}: `}
              </Typography.Text>
              {moment.unix(item.started_on).utc().format('DD/MM/YYYY HH:mm')}
            </Row>
            <Row>
              <Typography.Text strong>
                {`${t('web.itinerary.form.end')}: `}
              </Typography.Text>
              {moment.unix(item.ended_on).utc().format('DD/MM/YYYY HH:mm')}
            </Row>
          </>
        }
      />
    </List.Item>
  )
}

export default ItineraryItem
